import { AxiosInstance, isAxiosError } from 'axios'
import { ConsultaResponse } from './consulta-response'
import { IncluirRequest } from './incluir-request'
import { AtualizarRequest } from './atualizar-request'
import { RemoveRequest } from './remove-request'

export class DocLinhaService {
    constructor(
        private api: AxiosInstance
    ) { }

    async consulta(codigo_doc: number): Promise<ConsultaResponse> {
        try {
            let { data } = await this.api.get<ConsultaResponse>(`docs/doc-linha`, {
                params: {
                    codigo_doc
                }
            })
            if (!data.sucesso) {
                throw new Error(data.mensagem);
            }
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                error = new Error(error.response?.data?.error || 'Não foi possível consultar as linhas do doc')
            }
            throw error
        }
    }

    async incluir(request: IncluirRequest): Promise<ConsultaResponse> {
        try {
            let { data } = await this.api.post<ConsultaResponse>(`docs/doc-linha/inserir`, request)
            if (!data.sucesso) {
                throw new Error(data.mensagem);
            }
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                error = new Error(error.response?.data?.error || 'Não foi possível incluir a linha do doc')
            }
            throw error
        }
    }

    async atualizar(request: AtualizarRequest): Promise<ConsultaResponse> {
        try {
            let { data } = await this.api.post<ConsultaResponse>(`docs/doc-linha/atualizar`, request)
            if (!data.sucesso) {
                throw new Error(data.mensagem);
            }
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                error = new Error(error.response?.data?.error || 'Não foi possível alterar a linha do doc')
            }
            throw error
        }
    }

    async remove(request: RemoveRequest): Promise<ConsultaResponse> {
        try {
            let { data } = await this.api.delete<ConsultaResponse>(`docs/doc-linha/remove`, {
                data: {
                    ...request
                }
            })
            if (!data.sucesso) {
                throw new Error(data.mensagem);
            }
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                error = new Error(error.response?.data?.error || 'Não foi possível alterar a linha do doc')
            }
            throw error
        }
    }
}